<template>
    <v-app id="inspire">
        <v-navigation-drawer v-model="drawer" app clipped expand-on-hover>
            <v-list dense>
                <v-list-item v-for="item in items" :key="item.text" link :to="item.redirect">
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group v-for="item in dropItems" :key="item.text" v-model="item.model" :append-icon="item.model ? item.icon : item['icon-alt']" prepend-icon="mdi-magnify">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.redirect">
                        <v-list-item-action v-if="child.icon" id="subnavIcon">
                            <v-icon small>{{ child.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title id="subnavText">
                                {{ child.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <!-- <v-subheader class="mt-4 grey--text text--darken-1">SUBSCRIPTIONS</v-subheader> -->
                <!-- <v-divider
            dark
            class="my-4"
          ></v-divider>
        <v-list-item
          class="mt-4"
          link
          to='/logout'
        >
          <v-list-item-action>
            <v-icon color="grey lighten-1">mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Logout</v-list-item-title>
        </v-list-item> -->
                <!-- <v-list-item link to='/admin/settings'>
          <v-list-item-action>
            <v-icon color="grey lighten-1">mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-title class="grey--text text--darken-1">Settings</v-list-item-title>
        </v-list-item> -->
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app clipped-left color="white" dense>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="blue darken-4"></v-app-bar-nav-icon>
            <!-- <v-img src="./assets/icon.png" id="sidebarLogo"></v-img> -->

            <v-toolbar-title class="mr-12 align-center">
                White-Leaves
                <!-- <v-img src="./assets/logo-text.png" id="logotext"></v-img> -->
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-row align="center" style="max-width: 650px">
                <v-text-field :append-icon-cb="() => {}" placeholder="Search..." single-line append-icon="mdi-magnify" color="orange darken-3" hide-details></v-text-field>
            </v-row>
        </v-app-bar>

        <v-main id="content">
            <!-- <v-container class="fill-height"> -->
            <div id="contentcontainter">
                <router-view></router-view>
            </div>
        </v-main>
    </v-app>
</template>
<script>
    export default {
        props: {
            source: String
        },
        data: () => ({
            drawer: true,
            dropItems: [
                //
            ],
            items: [
                { icon: "mdi-cash-multiple", text: "Umsätze", redirect: "/turnover" }
                // { icon: "mdi-cash-multiple", text: "Monitoring", redirect: "/monitoring" }
                // { icon: 'mdi-trending-up', text: 'Rankings', redirect: '/' },
            ]
        }),
        methods: {},
        created() {
            // this.$vuetify.theme.dark = true
        }
    }
</script>
<style scoped>
    .v-list-group__header {
        height: 100px !important;
    }
    #logotext {
        max-width: 150px;
        padding-left: 10px;
        margin-top: 1px !important;
    }
    #sidebarLogo {
        margin-left: 5px;
        margin-right: 5px;
        max-width: 50px;
    }
    #navtitle {
        font-weight: bold;
        margin-top: 9px !important;
        margin-left: 0px;
        color: rgb(88, 88, 88);
        font-size: 13px !important;
    }
    #content {
        background-color: rgb(236, 236, 236);
    }
    #contentcontainter {
        margin: auto;
        width: 80%;
        padding-top: 30px;
    }
    #subnavIcon {
        padding-left: 39px;
        padding-right: 0px;
        margin-right: 10px;
    }
    #subnavText {
        padding-left: 0px !important;
    }
</style>
